import styled from 'styled-components';
import { Table, TableHeaderCell, TableRow } from '@spotify-internal/encore-web';
import { ProfileProtection } from '@hooks/useGetProfileProtectionData';
import { useProfileProtectionsCopy } from '@hooks/useProfileProtectionsCopy';
import { ApprovalStatusInfoPopover } from '@components/shared/ApprovalStatusInfoPopover';

import { ProfileProtectionsTableRow } from './ProfileProtectionsTableRow';

const HeaderCellContent = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

const TableHeaderCellVerticalAlign = styled(TableHeaderCell)`
  vertical-align: middle;
`;

interface ProfileProtectionsTableProps {
  rows: ProfileProtection[];
}

export const ProfileProtectionsTable = ({
  rows,
}: ProfileProtectionsTableProps) => {
  const copy = useProfileProtectionsCopy();

  return (
    <Table>
      <colgroup>
        <col width="10%" />
        <col width="12%" />
        <col width="18%" />
        <col width="13%" />
        <col width="16%" />
        <col width="7%" />
        <col width="7%" />
        <col width="11%" />
        <col width="6%" />
      </colgroup>
      <thead>
        <TableRow>
          <TableHeaderCellVerticalAlign>
            {copy.feedName}
          </TableHeaderCellVerticalAlign>
          <TableHeaderCellVerticalAlign>
            {copy.licensorName}
          </TableHeaderCellVerticalAlign>
          <TableHeaderCellVerticalAlign>
            {copy.productDetails}
          </TableHeaderCellVerticalAlign>
          <TableHeaderCellVerticalAlign>
            <HeaderCellContent>
              <span>{copy.approvalStatus}</span>
              <ApprovalStatusInfoPopover />
            </HeaderCellContent>
          </TableHeaderCellVerticalAlign>
          <TableHeaderCellVerticalAlign>
            {copy.primaryReleaseId}
          </TableHeaderCellVerticalAlign>
          <TableHeaderCellVerticalAlign>
            {copy.productType}
          </TableHeaderCellVerticalAlign>
          <TableHeaderCellVerticalAlign>
            {copy.includedMedia}
          </TableHeaderCellVerticalAlign>
          <TableHeaderCellVerticalAlign>
            {copy.originalReleaseDate}
          </TableHeaderCellVerticalAlign>
          <TableHeaderCellVerticalAlign>
            {copy.copyUri}
          </TableHeaderCellVerticalAlign>
        </TableRow>
      </thead>
      <tbody>
        {rows.map(row => (
          <ProfileProtectionsTableRow key={row.uri} row={row} />
        ))}
      </tbody>
    </Table>
  );
};
